import { useMemo } from 'react';
import { IMicrositeRecipientPendApproval } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, FirstDataRenderedEvent, ICellRendererParams } from 'ag-grid-community';
import styled from 'styled-components';
import { Button, Modal } from 'react-bootstrap';

const GridWrapper = styled.div`
    font-family: Roboto;

    height: 400px;
    width: 100%;

    .header {
        background-color: #ddd;
        font-weight: bold;
    }

    .header-center > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-cell {
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: #ddd;
    }
`;

interface IProps {
    list: IMicrositeRecipientPendApproval[],
    show: boolean,
    centerId: number,
    onClose: () => void
}

const MicrositePendingApproval = (props: IProps) => {
    const columns: ColDef[] = [
        {
            headerName: 'Recipient First Name',
            headerClass: 'header',
            field: 'recipientFirstName',
            width: 200,
            suppressSizeToFit: true,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IMicrositeRecipientPendApproval;
                return (
                    <span>{data.recipientFirstName}</span>
                );
            }
        },
        {
            headerName: 'Recipient Last Name',
            headerClass: 'header',
            field: 'recipientLastName',
            width: 200,
            suppressSizeToFit: true,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IMicrositeRecipientPendApproval;
                return (
                    <span>{data.recipientLastName}</span>
                );
            }
        },
        {
            headerName: 'Complete',
            headerClass: 'header header-center',
            width: 650,
            suppressSizeToFit: true,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IMicrositeRecipientPendApproval;

                return (
                    <span>To approve the custom site for this microsite patient, please
                        <a href={`center/${data.centerId}/microsite/${data.micrositeRecipientId}/approve?previous=3`} target='_blank'>&nbsp;click here</a>.
                    </span>
                );
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.list, [props.list]);

    return (<>
        <Modal backdrop='static' className='modal-xxl' bsSize='lg' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Microsites Pending Approval</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <GridWrapper className='ag-theme-bootstrap'>
                    <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        suppressCellSelection={true}
                        suppressRowClickSelection={true}
                        onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                    />
                </GridWrapper>
            </Modal.Body>
            <Modal.Footer>

                <Button onClick={props.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    </>);
}

export default MicrositePendingApproval;